import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";



//get all users
export const getAllPackages = createAsyncThunk(
    "/usersSlice/getAllPackages",
    async ({branchId}) => {
        try {
            const response = await useGetDataToken(`/api/v1/packages?branchId=${branchId}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getPackageServices = createAsyncThunk(
    "/usersSlice/getPackageServices",
    async ({Id}) => {
        try {
            const response = await useGetDataToken(`/api/v1/packages/servicesForPackage/${Id}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


